/* eslint-disable max-len */
import { FilterBy } from '@1po/1po-bff-fe-spec/generated/common/filter_and_sort/FilterBy';
import { FilterAndSortField as MyNetworkClientsFilterAndSortField } from '@1po/1po-bff-fe-spec/generated/my_network/request/model/FilterAndSortField';
import { FilterOperator } from 'utils/types';

export const getMyNetworkClientsFilterArray = (
  filters: Map<MyNetworkClientsFilterAndSortField, string>,
): FilterBy<MyNetworkClientsFilterAndSortField>[] => {
  return Array.from(filters.entries()).map(
    ([field, value]) => new FilterBy<MyNetworkClientsFilterAndSortField>(field, value, FilterOperator.CONTAINS),
  );
};
